import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["preview", "settings"];
  static values = {
    addPath: String,
    updatePositionsPath: String,
  };

  connect() {
    this.initializeSortable();
    this.initializeAvailableSections();
  }

  initializeSortable() {
    Sortable.create(this.previewTarget, {
      animation: 150,
      handle: ".section-wrapper",
      draggable: ".section-wrapper",
      ghostClass: "opacity-50",
      chosenClass: "ring-2 ring-indigo-500",
      dragClass: "cursor-grabbing",
      group: {
        name: "sections",
        pull: true,
        put: true,
      },
      onEnd: this.handleSortEnd.bind(this),
    });
  }

  initializeAvailableSections() {
    document.querySelectorAll(".grid-cols-1").forEach((container) => {
      Sortable.create(container, {
        animation: 150,
        sort: false,
        group: {
          name: "sections",
          pull: "clone",
          put: false,
        },
        onClone: (evt) => {
          evt.clone.classList.add("section-wrapper");
        },
      });
    });
  }

  handleDragStart(event) {
    event.target.classList.add("opacity-50");
    event.dataTransfer.setData(
      "application/json",
      JSON.stringify({
        sectionId: event.currentTarget.dataset.sectionId,
      })
    );
  }

  handleDragOver(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    this.highlightDropZone(event.target);
  }

  handleDragEnd(event) {
    event.preventDefault();
    event.target.classList.remove("opacity-50");
    this.removeDropZoneHighlights();
  }

  handleDrop(event) {
    event.preventDefault();
    this.removeDropZoneHighlights();

    try {
      const data = JSON.parse(event.dataTransfer.getData("application/json"));

      fetch(this.addPathValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        },
        body: JSON.stringify({ section_id: data.sectionId }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then((html) => {
          this.previewTarget.insertAdjacentHTML("beforeend", html);
        })
        .catch((error) => {
          console.error("Section add error:", error);
          this.showError("Failed to add section");
        });
    } catch (error) {
      console.error("Drop error:", error);
      this.showError("Invalid section data");
    }
  }

  handleSortEnd(event) {
    if (!event.item) return;

    const positions = {};
    this.previewTarget
      .querySelectorAll("[data-section-position]")
      .forEach((el, index) => {
        positions[el.dataset.sectionId] = index + 1;
      });

    fetch(this.updatePositionsPathValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
      body: JSON.stringify({ positions }),
    }).catch((error) => {
      console.error("Position update error:", error);
      this.showError("Failed to update positions");
    });
  }

  highlightDropZone(element) {
    const dropZone = element.closest("[data-section-builder-target='preview']");
    if (dropZone) dropZone.classList.add("ring-2", "ring-indigo-500");
  }

  removeDropZoneHighlights() {
    document
      .querySelectorAll("[data-section-builder-target='preview']")
      .forEach((el) => el.classList.remove("ring-2", "ring-indigo-500"));
  }

  showError(message) {
    // Add error notification implementation here
    console.error(message);
  }
}
